import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/data-integration/HeroSection";
import { FeaturesSection } from "@/components/data-integration/FeaturesSection";
import { ProcessSection } from "@/components/data-integration/ProcessSection";
import { BenefitsSection } from "@/components/data-integration/BenefitsSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const DataIntegration = () => {
  return (
    <ServiceLayout serviceName="Data Integration">
      <HeroSection />
      <FeaturesSection />
      <ProcessSection />
      <BenefitsSection />
      <ServiceFAQ faqs={serviceFAQs["data-integration"]} serviceName="Data Integration" />
      <ServiceCTA serviceName="Data Integration" />
    </ServiceLayout>
  );
};

export default DataIntegration;